<script setup lang="ts">
import { ref, Ref, watch } from 'vue'
import CameraPicker from '@/components/formComponents/CameraPicker.vue'
import { TagSelector } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'
import _ from 'lodash'

const model = defineModel<TagSelector<'camera'>>()

const cameraIds: Ref<string[]> = ref([])
const useAllCameras: Ref<boolean> = ref(true)
const groupByCamera: Ref<boolean> = ref(true)

watch(
  model,
  () => {
    if (!model.value) return
    if (useAllCameras.value !== model.value.useAll) useAllCameras.value = model.value.useAll
    if (groupByCamera.value !== model.value.groupByValues) groupByCamera.value = model.value.groupByValues
    if (model.value.specificValues || !_.isEqual(cameraIds.value, model.value.specificValues)) {
      cameraIds.value = model.value.specificValues || []
    } else {
      cameraIds.value = []
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => [cameraIds, useAllCameras, groupByCamera],
  () => {
    const newModel: TagSelector<'camera'> = {
      tag: 'camera',
      useAll: useAllCameras.value,
      groupByValues: groupByCamera.value,
      allowEmptyValues: false, //should never happen anyway
    }
    if (!useAllCameras.value) newModel.specificValues = cameraIds.value
    if (_.isEqual(model.value, newModel)) return
    model.value = newModel
  },
  { immediate: true, deep: true }
)
</script>

<template>
  <v-switch
    v-model="groupByCamera"
    :label="$t('chart_sharing.creator.customize.tag_selectors.camera.group_by')"
    hide-details
  />
  <v-switch
    v-model="useAllCameras"
    :label="$t('chart_sharing.creator.customize.tag_selectors.camera.use_all')"
    hide-details
  />
  <v-fade-transition>
    <CameraPicker
      v-if="!useAllCameras"
      v-model="cameraIds"
      prepend-icon="mdi-cctv"
      :label="$t('chart_sharing.creator.customize.tag_selectors.camera.specific')"
      multiple
      :disabled="useAllCameras"
      hide-details
    />
  </v-fade-transition>
</template>
